import React, { useContext, useState } from 'react'
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import jadlogIcon from '../../images/png/jadlogIcon.jpg'
import trackenIcon from '../../images/png/trackenIcon.png'
import changeIcon from '../../images/png/changeIcon.png'
import xlsIcon from '../../images/png/xls.png'
import { ToastContainer } from 'react-toastify';
import { RequestsContext } from '../../context/requests';
import { FilterSallesContext } from '../../context/filterSalles';

const CardWrapper = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
`

const BoxStatus = styled.div`

    display: flex;
    padding-top: 0.9rem;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    height: 420px;

`

const ButtonEl = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items:center;
    color:black;
    background-color: white;
    width: 90%;
    min-height: 50px;
    border: 1px solid #dddddd;
    margin-top: 0.9rem;
    border-radius: 5px;

    p{
        height: 10px;
    }

`
const Image = styled.img`
    object-fit: contain;
    width:40px;
    height:40px;
    margin-left: 0.5rem;

`


const ModalTag = ({ props }) => {
    const { requests, handleGenerateReportAllFlex, handleGenerateReportAllJadlog, handleGenerateReportAllDeclaration, handleUpdateAllRequests, storageExcel } = useContext(RequestsContext)
    const [status, setStatus] = useState()

    const handleChackStatus = () => {
        setStatus(1)

    }

    const handleCloseClick = () => {
        props.onHide(); // Fechar a modal após adicionar
    }

    return (

        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Selecione uma opção
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>

                    {status == 1

                        ?


                        <BoxStatus>
                            <ButtonEl onClick={() => { handleUpdateAllRequests(2); handleCloseClick() }}>
                                <p>Separando</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => {handleUpdateAllRequests(8);handleCloseClick()}}>
                                <p>Aprovado</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => {handleUpdateAllRequests(8);handleCloseClick()}}>
                                <p>Preparando envio</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => {handleUpdateAllRequests(7);handleCloseClick()}}>
                                <p>Faturado</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => { handleUpdateAllRequests(3); handleCloseClick() }}>
                                <p>Produzindo</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => { handleUpdateAllRequests(4); handleCloseClick() }}>
                                <p>Embalado</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => { handleUpdateAllRequests(5); handleCloseClick() }}>
                                <p>Enviado</p>
                            </ButtonEl>
                            <ButtonEl onClick={() => { handleUpdateAllRequests(9); handleCloseClick() }}>
                                <p>Entregue</p>
                            </ButtonEl>
                            <ButtonEl >
                                <p>Não Entregue</p>
                            </ButtonEl>
                            <ButtonEl >
                                <p>Dados incompletos
                                </p>
                            </ButtonEl>
                            <ButtonEl onClick={() => { handleUpdateAllRequests(6); handleCloseClick() }}>
                                <p>Cancelado</p>
                            </ButtonEl>
                        </BoxStatus>
                        :

                        <>
                            {requests?.some(item => item.type_delivery == "1") && (
                                <ButtonEl onClick={() => handleGenerateReportAllFlex()}>
                                    <p>Etiqueta Flex</p>
                                    <Image src={trackenIcon} />
                                </ButtonEl>
                            )}


                            <ButtonEl onClick={() => handleChackStatus()}>
                                <p>Mudar Status</p>
                                <Image src={changeIcon} />
                            </ButtonEl>


                            {requests?.some(item => item.type_delivery == "2") && (
                                <ButtonEl onClick={() => handleGenerateReportAllJadlog()}>
                                    <p>Etiqueta Jadlog</p>
                                    <Image src={jadlogIcon} />
                                </ButtonEl>
                            )}
                            <ButtonEl onClick={() => handleGenerateReportAllDeclaration()}>
                                <p>Declaração de conteúdo</p>
                            </ButtonEl>

                            <ButtonEl onClick={() => storageExcel()}>
                                <p>Exportar Excel</p>
                                <Image src={xlsIcon} />

                            </ButtonEl>
                        </>

                    }


                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleCloseClick()}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalTag